import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles.sass';

const HamburgerIcon = ({ isAmp, onClick }) => (
  <button
    type="button"
    className={styles.wrapper}
    on={isAmp ? 'tap:sidebar.toggle' : null}
    onClick={onClick}
  >
    <div className={styles.lineContainer}>
      <span className={styles.line} />
      <span className={styles.line} />
      <span className={styles.line} />
    </div>
  </button>
);

HamburgerIcon.defaultProps = {
  isAmp: false,
  onClick: () => {},
};
HamburgerIcon.propTypes = {
  isAmp: PropTypes.bool,
  onClick: PropTypes.func,
};

export { HamburgerIcon };
